import { updateItem } from '@directus/sdk';
import { useMutation } from '@tanstack/react-query';

import type { Promoter } from '../../../../types/DirectusSchema';
import { directusClient } from '../../services/directusClient/directusClient.ts';
import { tanstackQueryClient } from '../../services/tanstackQueryClient.ts';
import { getPromoterId } from '../user/getPromoterId.ts';
import { useUserQuery } from '../user/useUserQuery.ts';

export const usePromoterItemUpdateMutation = () => {
  const { data } = useUserQuery();
  const promoterId = getPromoterId(data);

  return useMutation({
    mutationFn: async (updateData: Partial<Promoter>) => {
      if (!promoterId) throw new Error('Promoter data not loaded');
      await directusClient.request(updateItem('promoters', promoterId, updateData));
    },
    onSuccess: async () => {
      await tanstackQueryClient.invalidateQueries({
        queryKey: ['promoter', promoterId],
      });
    },
  });
};
